module.exports = __webpack_public_path__ + "static/media/ICT-9.44e9e1f5.png";